import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SectionHeader } from "./Services";

export default function Why({ content }) {
  const items = content?.why || [];
  return (
    <section id="por-que" className="relative py-24 sm:py-28 px-5 sm:px-8 lg:px-12">
      <div className="max-w-7xl mx-auto">
        <SectionHeader eyebrow="Por qué LUVA" title="Por qué nuestros clientes nos eligen" />
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line-2 border border-line-2">
          {items.map((it, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 14 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-50px" }} transition={{ duration: 0.45, delay: (i%3)*0.06 }}
              className="bg-surface p-7">
              <div className="w-9 h-9 border border-line flex items-center justify-center bg-base">
                <Check className="w-4 h-4 text-brand" />
              </div>
              <h4 className="mt-5 text-fg text-[18px] font-semibold leading-tight">{it.title}</h4>
              <p className="mt-2.5 text-mute text-[14px] leading-relaxed">{it.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
